// extracted by mini-css-extract-plugin
export default {"selector":"Selector_selector__bsO8s"};